/*
 * @Author: Json Chen
 * @Date: 2021-06-28 10:00:19
 * @LastEditTime: 2022-06-02 14:34:47
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/ProductAttributeAdvancedTable.tsx
 */
import { Button, SizeFittingTable } from '@/src/components/Antd';
import ModalDelHOC from '@/src/constrains/ModalDelHOC';
import React from 'react';
import styles from '../style.module.less';
import ProductAttributeAdvancedModalForm from './ProductAttributeAdvancedModalForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TIPCONTENTSTRATEGY = ({ getI18n }) => ({
  confirm: {
    title: getI18n('storeProductSetting.detail.deleteAdvancedProductAttribute'),
    content: getI18n(
      'storeProductSetting.detail.deleteAdvancedProductAttributeContent',
    ),
    buttonType: 'primary',
    okText: getI18n('general.confirm'),
  },
  delete: {
    title: getI18n('storeProductSetting.detail.deleteAdvancedProductAttribute'),
    content: getI18n(
      'storeProductSetting.detail.deleteAdvancedProductAttributeContent2',
    ),
    buttonType: 'danger',
    okText: getI18n('general.delete'),
  },
});
const ProductAttributeAdvancedTable = ({
  value: attrTableData = [],
  onChange,
  onDelClick,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  // modal visible
  const [attrVisible, setAttrVisible] = React.useState<boolean>(false);
  // attr的index 如果是添加 那么为 -1
  const [attrIndex, setAttrIndex] = React.useState<number>(-1);

  const onAttrActionEditClick = (column, index) => {
    setAttrIndex(index);
    setAttrVisible(true);
  };

  const showAttrModal = () => {
    setAttrVisible(true);
  };
  const hideAttrModal = () => {
    setAttrVisible(false);
    setAttrIndex(-1);
  };

  const onModalConfirm = (data) => {
    onChange(data);
    hideAttrModal();
  };

  const attrColumns = [
    {
      title: getI18n('storeProductSetting.detail.attributeTitle'),
      key: 'title',
      dataIndex: 'title',
      default: true,
      width: 256,
      childGenerate: (text) => {
        return <div className={styles.tb}>{text}</div>;
      },
    },
    {
      title: getI18n('storeProductSetting.detail.fieldType'),
      key: 'fieldType',
      dataIndex: 'fieldType',
      default: true,
      width: 224,
      childGenerate: (text, record) => {
        return (
          <div className={styles.tb}>
            {text}
            {record.unique && record.fieldType === 'InputField'
              ? ` (${getI18n('storeProductSetting.detail.uniqueValueO')})`
              : ''}
          </div>
        );
      },
    },
    {
      title: getI18n('storeProductSetting.detail.attributeOptions'),
      dataIndex: 'options',
      key: 'options',
      default: true,
      width: 480,
      textWrap: 'word-break',
      childGenerate: (option, record) => {
        return (
          <div className={styles.tb}>
            {record.options
              ? record.options.map((o) => o.value).join(' , ')
              : '-'}
          </div>
        );
      },
    },
    disabled
      ? {}
      : {
          title: getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
          default: true,
          optional: true,
          align: 'center',
          width: 128,
          childGenerate: (_, record, index) => {
            return (
              <div className={styles.action}>
                <span
                  className={styles.primary}
                  onClick={() => onAttrActionEditClick(record, index)}>
                  {getI18n('general.edit')}
                </span>
                <span
                  className={styles.danger}
                  onClick={() => onDelClick(index)}>
                  {getI18n('general.delete')}
                </span>
              </div>
            );
          },
        },
  ];

  return (
    <>
      {attrTableData.length ? (
        <SizeFittingTable
          rowKey='title'
          pagination={false}
          id='StoreSettingsProductAttributeAdvanced'
          className={styles.table}
          dataSource={attrTableData}
          columns={attrColumns}
        />
      ) : (
        <div className={styles.noresult}>
          {getI18n('storeProductSetting.detail.noadvancedproductattribute')}
        </div>
      )}

      <Button
        type='primary'
        // htmlType='button'
        onClick={showAttrModal}
        disabled={disabled}>
        {getI18n('storeProductSetting.detail.addProductAttribute')}
      </Button>

      <ProductAttributeAdvancedModalForm
        visible={attrVisible}
        attrData={attrTableData}
        attrIndex={attrIndex}
        onCancel={hideAttrModal}
        onModalConfirm={onModalConfirm}
      />
    </>
  );
};

export default ModalDelHOC(ProductAttributeAdvancedTable, {
  modalDataStrategy: TIPCONTENTSTRATEGY,
  canDel: ({ list, index }) => {
    // 返回true,则可以被删除,否则不能被删除
    return list[index].deletable;
  },
});
